// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fc3621de","239":"eab0352a","455":"fdaa2e0a"}[chunkId] + ".chunk.js";
};